import React from "react";
import PropTypes from "prop-types";
const CircleTick = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h24v24H-2z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="M13.391.59a1 1 0 0 1-.678 1.881A8 8 0 1 0 18 10a1 1 0 0 1 2 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0c1.17 0 2.313.201 3.391.59z" />
        <path d="M17.286 3.3a1 1 0 1 1 1.428 1.4l-7.854 8a1 1 0 0 1-1.43-.002L6.284 9.472a1 1 0 1 1 1.432-1.396l2.433 2.494 7.137-7.27z" />
      </g>
    </g>
  </svg>
);
CircleTick.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default CircleTick;
